import { Button, Form } from '@themesberg/react-bootstrap';
import { returnUserReadableDate } from '../../utils/datetime';
import {
  getTableRowCheckBox,
  returnCustomerAddressString,
} from '../../utils/table';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faRemove } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { unpaidTripCategories } from '../../utils/constants';
import { formatToINR } from '../../utils/sms/constantsAndUtils';
import ActionButton from '../oms/interBranchTransfers/components/ActionButton';
import { exportPerDeliverySummary } from '../../utils/excel';

export const inputValidate = (data, setFormErrors) => {
  const errors = {};
  let isValid = true;
  if (!data.fromDate && !data.toDate) {
    errors['fromDate'] = ' Both cannot be Empty';
    errors['toDate'] = 'Both cannot be Empty';
    isValid = false;
  }
  if (data.toDate < data.fromDate) {
    errors['toDate'] = 'Cannot be before From Date';
    isValid = false;
  }
  if (data.vehicleNumber.length > 11) {
    errors['vehicleNumber'] = 'Length cannot be more than 11';
    isValid = false;
  }
  // if (!data.vehicleNumber && !data.vendorName) {
  //   errors['vendorName'] = 'Both cannot be Empty!';
  //   errors['vehicleNumber'] = 'Both cannot be Empty!';
  //   isValid = false;
  // }
  setFormErrors(errors);
  return isValid;
};

export const paymentInputValidate = (formInput, setFormErrors) => {
  const errors = {};
  let isValid = true;
  if (!formInput.paymentMethod) {
    errors['paymentMethod'] = 'Cannot be Empty!';
    isValid = false;
  }
  if (!formInput.invoiceNumber) {
    errors['invoiceNumber'] = 'Cannot be Empty!';
    isValid = false;
  }

  if (!formInput.invoiceDate) {
    errors['invoiceDate'] = 'Cannot be Empty!';
    isValid = false;
  }
  if (!formInput.paymentDate) {
    errors['paymentDate'] = 'Cannot be Empty!';
    isValid = false;
  }
  if (!formInput.paymentRemarks) {
    errors['paymentRemarks'] = 'Cannot be Empty!';
    isValid = false;
  }
  setFormErrors(errors);
  return isValid;
};
export const perDeliveryColumns = ({
  onRowSelect,
  isModal,
  handleInputChange,
  isFinalTextField,
  isDelete,
  setFunction,
  isdisabled,
  isPaid,
  isEdit,
  editFunction,
}) => {
  const columns = [
    {
      dataField: 'tripNumber',
      text: 'Trip Info.',
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-block">No: {cell}</div>
            <div className="d-block">Zone: {row.zone}</div>
            {returnCustomerAddressString(row.vehicleArea)}
          </>
        );
      },
    },
    {
      dataField: 'vendorName',
      text: 'Vendor Name',
      formatter: (cell, row) => {
        return <div className="d-block">{row?.driverInfo?.vendorName}</div>;
      },
    },
    {
      dataField: 'driverInfo',
      text: 'Vehicle Details',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <div>{cell?.vehicleNumber}</div>
            <div>{cell?.paymentMode}</div>
            <div>{cell?.paymentAmount}</div>
            <div>{cell?.vehicleType}</div>
          </div>
        );
      },
    },
    {
      dataField: 'deliveryRateInfo',
      text: 'Deliveries',
      formatter: (cell, row) => {
        const deliveryQuantity =
          (cell?.deliveryQuantity || cell?.gtCount || 0) +
          (cell?.defectivePicked || 0) +
          (cell?.package || 0);
        return (
          <>
            <div className="d-block">
              <div>{`Quantity - ${deliveryQuantity}`}</div>
              <div>{`DroppedAtHub - ${cell?.droppedAtHub || 0}`}</div>
              <div>{`Failed - ${cell?.failed || 0}`}</div>
            </div>
          </>
        );
      },
    },
    {
      dataField: 'tripDate',
      text: 'Trip Date',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            {returnUserReadableDate(row.dispatchedAt)}
          </div>
        );
      },
    },
    {
      dataField: 'totalAmount',
      text: 'Total Amount',
    },
    {
      dataField: 'isManualCalculation',
      text: 'Edited',
      formatter: (cell, row) => {
        const lastPaymentUpdate = row.actionLog?.findLast(
          (item) => item.action === 'paymentUpdated'
        )?.userName;
        return (
          <div className="d-block">
            <div>{cell ? `Yes by` : 'No'}</div>
            {cell && lastPaymentUpdate && <div>{lastPaymentUpdate}</div>}
          </div>
        );
      },
    },
  ];
  if (!isModal) {
    columns.splice(0, 0, {
      dataField: 'objectId',
      text: 'Select',
      formatter: (cell, row) => {
        return getTableRowCheckBox(onRowSelect, cell, row?.isSelected, false);
      },
    });
  }
  if (isFinalTextField) {
    columns.push({
      dataField: 'finalPayment',
      text: 'Final Payment',
      formatter: (cell, row) => {
        return (
          <Form.Group>
            <Form.Control
              type="number"
              id={row.objectId}
              value={cell}
              onChange={(e) => handleInputChange(row.objectId, e)}
              disabled={isdisabled}
            />
          </Form.Group>
        );
      },
    });
  }

  if (isPaid) {
    columns.push({
      dataField: 'finalPayment',
      text: 'Final Payment',
    });
  }

  if (isDelete) {
    columns.push({
      dataField: 'objectId',
      text: '',
      formatter: (cell, row) => {
        return (
          <Button
            onClick={() => {
              setFunction((prev) =>
                prev.filter((item) => item.objectId !== cell)
              );
            }}
          >
            <FontAwesomeIcon icon={faRemove} />
          </Button>
        );
      },
    });
  }

  if (isEdit) {
    columns.push({
      dataField: 'edit',
      text: 'Edit',
      formatter: (cell, row) => {
        return (
          <Button onClick={() => editFunction(row?.tripNumber)}>
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        );
      },
    });
  }
  return columns;
};
export const unpaidTripsColumns = ({ onRowSelect, handleViewClick }) => {
  const columns = [
    {
      dataField: 'date',
      text: 'Date',
    },
    {
      dataField: 'vehicleDetails',
      text: 'Vehicle Number',
      formatter: (cell, row) => {
        return (
          <>
            <div>{cell?.vehicleNumber}</div>
            <div>{cell?.vehicleType}</div>
          </>
        );
      },
    },
    {
      dataField: 'vehicleDetails.vendorName',
      text: 'Vendor',
      formatter: (cell, row) => {
        return cell;
      },
    },
    {
      dataField: 'attendance',
      text: 'Attendance',
      formatter: (cell, row) => {
        return (
          <>
            <div>
              Days Present: {`${row.totalPresent || 0}/${row.totalDays || 0}`}
            </div>
            <div>Trips: {row.totalTrips}</div>
            <div>Pending Trips: {row.pendingTrips}</div>
          </>
        );
      },
    },
    {
      dataField: 'vehicleDetails.paymentMode',
      text: 'Payment Details',
      formatter: (cell, row) => {
        return (
          <>
            <div>Type: {cell}</div>
            <div>
              Rate:
              {row.vehicleDetails?.paymentAmount}
            </div>
          </>
        );
      },
    },
    {
      dataField: 'deliverySummary',
      text: 'Delivery Summary',
      formatter: (cell, row) => {
        return (
          <>
            <div>Delivered: {row.totalDeliveryQuantity}</div>
            <div>Delivery Attempted: {row.totalDeliveryAttempted}</div>
            <div>Dropped At Hub: {row.droppedAtHub}</div>
            <div>Failed: {row.totalFailed}</div>
          </>
        );
      },
    },
    {
      dataField: '',
      text: 'Display/GT Summary',
      formatter: (cell, row) => {
        return (
          <>
            <div>Total Display: {row.totalDisplay}</div>
            <div>Display/GT Products: {row.totalDisplayProducts}</div>
          </>
        );
      },
    },
    {
      dataField: 'totalAmount',
      text: 'Total Amount',
      formatter: (cell, row) => {
        return (
          <>
            <div>Delivery: {cell?.toFixed(2) || 0}</div>
            <div>Voucher: {row.voucherAmount?.toFixed(2) || 0}</div>
            <div>
              Total: {((cell || 0) + (row.voucherAmount || 0)).toFixed(2)}
            </div>
          </>
        );
      },
    },
    {
      dataField: 'view',
      text: 'View',
      formatter: (cell, row) => {
        return (
          <FontAwesomeIcon
            icon={faEye}
            onClick={() => handleViewClick(row.objectId)}
          />
        );
      },
    },
  ];
  if (onRowSelect) {
    columns.unshift({
      dataField: 'objectId',
      text: 'Select',
      formatter: (cell, row) => {
        return getTableRowCheckBox(onRowSelect, cell, row?.isSelected, false);
      },
    });
  }
  return columns;
};

export const paidTripsColumns = () => {
  return [
    {
      dataField: 'invoiceNumber',
      text: 'Invoice No.',
    },
    {
      dataField: 'invoiceDate',
      text: 'Invoice Date',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            {returnUserReadableDate(row.invoiceDate)}
          </div>
        );
      },
    },
    {
      dataField: 'vendorName',
      text: 'Vendor Name',
    },
    {
      dataField: 'totalTrips',
      text: 'Total Trips',
    },
    {
      dataField: 'totalAmount',
      text: 'Total Amount',
      formatter: formatToINR,
    },
  ];
};

export const paidInputValidate = (data, setFormErrors) => {
  let isValid = true;
  let errors = {};
  if (!data.fromDate || !data.toDate) {
    errors['fromDate'] = 'Cannot be Empty';
    errors['toDate'] = 'Cannot be Empty';
    isValid = false;
  }
  if (data.toDate < data.fromDate) {
    errors['toDate'] = 'Cannot be before From Date';
    isValid = false;
  }
  setFormErrors(errors);
  return isValid;
};

export const getOrderCount = (num, category, zone) => {
  if (category === 'droppedAtHub' && zone === 'Mumbai') return 0;
  if (num <= 2 || category === 'droppedAtHub' || zone !== 'Mumbai') return 1;
  const total = Math.ceil((num - 2) / 3) + 1;
  return total;
};

export const getPerdeliveryRate = (category, zone) => {
  if (
    (category === 'droppedAtHub' && zone === 'Mumbai') ||
    unpaidTripCategories.includes(category)
  ) {
    return true;
  }
  return false;
};

export const tripsViewColumns = ({
  handleEditClick,
  handleSaveClick,
  onTripViewClick,
  isAdmin,
}) => {
  const columns = [
    {
      dataField: 'tripDetails',
      text: 'Trip Details',
      formatter: (cell, row) => {
        return (
          <>
            <div>
              <span>
                No: {row.tripNumber}
                {'  '}
              </span>
              <FontAwesomeIcon
                icon={faEye}
                onClick={() => onTripViewClick(row.objectId)}
              />
            </div>
            <div>Date: {row.date}</div>
          </>
        );
      },
    },
    {
      dataField: 'paymentMode',
      text: 'Payment Mode',
    },
    {
      dataField: 'totalDeliveryAttempted',
      text: 'Del. Attempted',
    },
    {
      dataField: 'totalDeliveryQuantity',
      text: 'Delivered',
    },
    {
      dataField: 'totalFailed',
      text: 'Failed',
    },
    {
      dataField: 'droppedAtHub',
      text: 'DroppedAtHub',
    },
    {
      dataField: 'totalDisplay',
      text: 'GT',
    },
    {
      dataField: 'totalDisplayProducts',
      text: 'GT Products',
    },
    {
      dataField: 'totalAmount',
      text: 'Trip Amount',
    },
    {
      dataField: 'voucherAmount',
      text: 'Vouchers',
    },
    {
      dataField: 'edited',
      text: 'Edited By',
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-block">{cell?.by || '-'}</div>
            <div className="d-block">
              {cell?.at ? returnUserReadableDate(cell?.at) : '-'}
            </div>
          </>
        );
      },
    },
  ];
  columns.push({
    dataField: '',
    text: handleSaveClick ? 'Edit' : 'View',
    formatter: (cell, row) => {
      return (
        <>
          {!row.paymentMode ? (
            <></>
          ) : ['monthlyFixed', 'extraVehicle'].includes(row?.paymentMode) ? (
            row.totalAmount || row.paymentDayType ? (
              <ActionButton
                options={['Full Day', 'Half Day', 'Leave']}
                onActionClick={(option) =>
                  handleEditClick(row?.objectId, option, row.totalAmount)
                }
              />
            ) : (
              <></>
            )
          ) : isAdmin ? (
            <FontAwesomeIcon
              icon={faEdit}
              onClick={() => handleEditClick(row.objectId)}
            />
          ) : (
            <></>
          )}
        </>
      );
    },
  });
  return columns;
};

export const getMonthStartEnd = (monthYearString) => {
  const [monthName, year] = monthYearString.split(' ');

  // Convert month name to month index (0-11)
  const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();

  // Get first and last day of the month
  const startDate = new Date(year, monthIndex, 1);
  const endDate = new Date(year, monthIndex + 1, 0);

  // Adjust for time zone differences by formatting date in 'YYYY-MM-DD'
  const formatDate = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(date.getDate()).padStart(2, '0')}`;

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
};

export const shortenTripsString = (arr) => {
  const map = {};

  arr.forEach((item) => {
    const parts = item?.split('/');
    const key = parts?.slice(0, -1).join('/');
    const value = parts?.[parts?.length - 1];

    if (!map[key]) {
      map[key] = [];
    }
    map[key].push(value);
  });

  return Object.entries(map)
    .map(([key, values]) => `${key}/${values.join(',')}`)
    .join(', ');
};

export const perTripData = (data) => {
  const result = data.map((item) => {
    return {
      tripNumber: item?.tripNumber,
      vendorName: item?.driverInfo?.vendorName,
      vehicleNumber: item.driverInfo?.vehicleNumber,
      paymentMode: item.driverInfo?.paymentMode,
      paymentAmount: item.driverInfo?.paymentAmount,
      vehicleType: item.driverInfo?.vehicleType,
      storeName: item?.driverInfo?.storeName,
      tripDate: returnUserReadableDate(item?.dispatchedAt),
      totalAmount: item?.totalAmount,
      'Edited By': item.actionLog?.findLast(
        (item) => item?.action === 'paymentUpdated'
      )?.userName,
    };
  });
  return result;
};

export const addMissingDates = (groupedByDate, startDateUTC, endDateUTC) => {
  const dateSet = new Set(Object.keys(groupedByDate));

  const formatToISTDateString = (date) => {
    const istDate = new Date(
      date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })
    );
    const dd = String(istDate.getDate()).padStart(2, '0');
    const mm = String(istDate.getMonth() + 1).padStart(2, '0');
    const yyyy = istDate.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  let current = new Date(startDateUTC);
  const end = new Date(endDateUTC);

  const allDatesInRange = [];

  while (current <= end) {
    const localDateStr = formatToISTDateString(current);
    allDatesInRange.push(localDateStr);
    current.setUTCDate(current.getUTCDate() + 1);
  }

  // Create ordered map
  const ordered = {};
  for (const dateStr of allDatesInRange) {
    if (groupedByDate[dateStr]) {
      ordered[dateStr] = groupedByDate[dateStr];
    } else {
      ordered[dateStr] = [];
    }
  }

  return ordered;
};

export const vehiclePaymentExport = ({
  extraData,
  userName,
  storeName,
  isBulkExport,
}) => {
  const totalAmount = {
    totalgtAmount: 0,
    totalCustQty: 0,
    totalgtQuantity: 0,
    totalCustAmount: 0,
    totalCustProduct: 0,
    totalgtProduct: 0,
  };
  let groupedByDate = extraData?.trips
    ?.filter((item) => item.status !== 'pending')
    ?.reduce((acc, trip) => {
      const date = trip.date;

      if (
        ['fixedPerDelivery', 'extraPerDelivery'].includes(trip?.paymentMode) &&
        trip.totalAmount <= 0
      ) {
        return acc;
      }

      const key = date;

      if (!acc[key]) {
        acc[key] = {
          trips: [],
          total: 0,
        };
      }

      const totalAmt = (trip.totalAmount || 0) + (trip.voucherAmount || 0);
      acc[key].trips.push(trip);
      acc[key].total += totalAmt;

      return acc;
    }, {});

  // Now remove entries with 0 total
  groupedByDate = Object.fromEntries(
    Object.entries(groupedByDate)
      .filter(([_, value]) => value.total > 0)
      .map(([key, value]) => [key, value.trips])
  );
  if (!isBulkExport) {
    groupedByDate = addMissingDates(
      groupedByDate,
      extraData.filter?.startDate,
      extraData.filter?.endDate
    );
  }

  let data = Object.entries(groupedByDate).map(([date, trips]) => {
    const result = {
      date,
      gtQuantity: 0,
      gtAmount: 0,
      extraCharges: 0,
      custQty: 0,
      totalQty: 0,
      custAmount: 0,
      custProduct: 0,
      gtProduct: 0,
      totalAmount: 0,
      tripNumbers: [],
    };

    trips.forEach((trip) => {
      if (trip.exportData) {
        const exportData = trip.exportData;
        result.gtQuantity += exportData.gt?.quantity || 0;
        result.gtAmount += exportData.gt?.amount || 0;
        result.gtProduct += exportData.gt?.product || 0;
        result.totalQty += exportData.gt?.quantity || 0;
        totalAmount.totalgtAmount += exportData.gt?.amount || 0;
        totalAmount.totalgtQuantity += exportData.gt?.quantity || 0;
        totalAmount.totalgtProduct += exportData.gt?.product || 0;
        result.custQty += exportData.custQty;
        result.custAmount += exportData.custAmount;
        result.custProduct += exportData.custProduct;
        result.totalQty += exportData.custQty;
        result.totalAmount +=
          (trip.totalAmount || 0) + (trip.voucherAmount || 0);
        totalAmount.totalCustQty += exportData.custQty;
        totalAmount.totalCustAmount += exportData.custAmount;
        totalAmount.totalCustProduct += exportData.custProduct || 0;
      } else {
        result.custQty += trip.totalDeliveryAttempted || 0;
        result.custProduct += trip.totalDeliveryQuantity || 0;
        result.gtQuantity +=
          (trip.totalDisplay || 0) + (trip.droppedAtHub || 0);
        result.gtProduct +=
          (trip.totalDisplayProducts || 0) + (trip.droppedAtHubProducts || 0);
        result.totalQty +=
          (trip.totalDeliveryAttempted || 0) +
          (trip.totalDisplay || 0) +
          (trip.droppedAtHub || 0);
        result.totalAmount +=
          (trip.totalAmount || 0) + (trip.voucherAmount || 0);
        totalAmount.totalgtAmount += trip.totalAmount || 0;
        totalAmount.totalCustQty += trip.totalDeliveryAttempted || 0;
        totalAmount.totalgtQuantity +=
          (trip.totalDisplay || 0) + (trip.droppedAtHub || 0);
        totalAmount.totalCustProduct += trip.totalDeliveryQuantity || 0;
        totalAmount.totalgtProduct +=
          (trip.totalDisplayProducts || 0) + (trip.droppedAtHubProducts || 0);
      }
      result.extraCharges += trip.voucherAmount || 0;
      result.tripNumbers.push(trip.tripNumber);
    });
    const output = {
      DATE: result.date,
      TEMPOSHEETS:
        result.tripNumbers.length > 0
          ? shortenTripsString(result.tripNumbers)
          : 'ABSENT',
      'CUST DEL': result.custQty,
      'CUST DEL PRODUCT QTY': result.custProduct,
      'CUST DEL AMOUNT': result.custAmount,
      'BR DISPLAY QTY': result.gtQuantity,
      'BR DISPLAY PRODUCT QTY': result.gtProduct,
      'BR DISPLAY AMOUNT': result.gtAmount,
      'EXTRA CHARGES': result.extraCharges,
      'TOTAL QTY': result.totalQty,
      'SHEET AMT': result.totalAmount,
    };
    if (
      ['monthlyFixed', 'extraVehicle', 'perTrip'].includes(
        extraData?.vehicleDetails?.paymentMode
      )
    ) {
      delete output['CUST DEL AMOUNT'];
      delete output['BR DISPLAY AMOUNT'];
    }
    return output;
  });
  const finalRow = {
    TEMPOSHEETS: 'TOTAL',
    'CUST DEL': totalAmount.totalCustQty,
    'BR DISPLAY QTY': totalAmount.totalgtQuantity,
    'CUST DEL PRODUCT QTY': totalAmount.totalCustProduct,
    'BR DISPLAY PRODUCT QTY': totalAmount.totalgtProduct,
    'EXTRA CHARGES': extraData?.voucherAmount,
    'TOTAL QTY': totalAmount.totalCustQty + totalAmount.totalgtQuantity,
    'SHEET AMT': extraData?.totalAmount?.toFixed(2),
  };
  if (
    !['monthlyFixed', 'extraVehicle', 'perTrip']?.includes(
      extraData?.vehicleDetails?.paymentMode
    )
  ) {
    finalRow['CUST DEL AMOUNT'] = totalAmount.totalCustAmount;
    finalRow['BR DISPLAY AMOUNT'] = totalAmount.totalgtAmount.toFixed(2);
  }
  data.push(finalRow);
  const details = {
    month: extraData.month,
    branchName: extraData?.vehicleDetails?.storeName || storeName,
    startDate: getMonthStartEnd(extraData.month).startDate,
    endDate: getMonthStartEnd(extraData.month).endDate,
    vendorName: extraData?.vehicleDetails?.vendorName,
    present: extraData.totalPresent,
    absent: extraData.totalDays - extraData.totalPresent,
    vehicleNumber: extraData?.vehicleDetails?.vehicleNumber,
    paymentMode: extraData?.vehicleDetails?.paymentMode,
    paymentAmount: extraData?.vehicleDetails?.paymentAmount,
    vehicleType: extraData?.vehicleDetails?.vehicleType,
    deliveryAverage: (finalRow['TOTAL QTY'] / extraData.totalPresent).toFixed(
      2
    ),
    deliveryAmountAverage: (
      finalRow['SHEET AMT'] / finalRow['TOTAL QTY']
    ).toFixed(2),
    userName,
    vendorDetails: extraData.vendorDetails,
    userDetails: extraData.preparedBy,
  };
  return { data, details };
};

export const mergeDeliverySummaries = (dataArray) => {
  const summary = {
    totalDeliveryQuantity: 0,
    totalDisplay: 0,
    totalAmount: 0,
    deliveryAmount: [],
    totalDisplayProducts: 0,
    totalDeliveryAttempted: 0,
    droppedAtHub: 0,
    droppedAtHubProducts: 0,
    buyback: 0,
    totalPresent: 0,
    totalTrips: 0,
    totalFailed: 0,
    pendingTrips: 0,
    voucherAmount: 0,
    totalDays: 0,
    paymentStatus: {
      paid: 0,
      unpaid: 0,
    },
    trips: [],
    uniqueDates: {},
  };

  dataArray.forEach((item, index) => {
    summary.totalDeliveryQuantity += item.totalDeliveryQuantity || 0;
    summary.totalDisplay += item.totalDisplay || 0;
    summary.totalAmount += item.totalAmount || 0;

    // Merge deliveryAmount as individual entries
    if (Array.isArray(item.deliveryAmount)) {
      summary.deliveryAmount.push(...item.deliveryAmount);
    }

    summary.totalDisplayProducts += item.totalDisplayProducts || 0;
    summary.totalDeliveryAttempted += item.totalDeliveryAttempted || 0;
    summary.droppedAtHub += item.droppedAtHub || 0;
    summary.droppedAtHubProducts += item.droppedAtHubProducts || 0;
    summary.buyback += item.buyback || 0;
    summary.totalPresent = Math.max(
      summary.totalPresent || 0,
      item.totalPresent || 0
    );
    summary.totalTrips += item.totalTrips || 0;
    summary.totalFailed += item.totalFailed || 0;
    summary.pendingTrips += item.pendingTrips || 0;
    summary.voucherAmount += item.voucherAmount || 0;

    summary.paymentStatus.paid += item.paymentStatus?.paid || 0;
    summary.paymentStatus.unpaid += item.paymentStatus?.unpaid || 0;

    if (Array.isArray(item.trips)) {
      summary.trips.push(
        ...item.trips.map((trip) => ({
          ...trip,
          vehicleDetails: item.vehicleDetails,
        }))
      );
    }

    // Optional: merge uniqueDates
    Object.assign(summary.uniqueDates, item.uniqueDates || {});

    // Copy shared static values from first object
    if (index === 0) {
      summary.vendorDetails = item.vendorDetails;
      summary.filter = item.filter;
      summary.month = item.month;
      summary.totalDays = item.totalDays || 0;
    }
  });

  return summary;
};
